module.exports = "/_next/static/images/60c2b2adc008cb04ea6d7cac5a2f098d-slide-4-small.png";